import React from 'react';
import { useDispatch } from 'react-redux';
import { closeModalAction } from '../../../actions/modal';
import Form from '../../../common/Form';
import { useForm } from 'react-hook-form';
import { addTeamsToChat } from '../../../actions/chat';
import Teams from '../../../components/Inputs/Teams';
import { useSelector } from 'react-redux';
const formName = 'addMemberConversation';

export default function AddTeamsInConversation({ conversationId, existingTeamIds, org_id }) {
    const dispatch = useDispatch();
    const closeModal = () => dispatch(closeModalAction());
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);

    const onSubmit = (form) => {
        dispatch(addTeamsToChat({ id: conversationId, teamIds: form.teams.map((team) => team.value), onSuccess: closeModal, formName }));
    };

    const methods = useForm({ mode: 'all' });

    return (
        <Form
            onSubmit={onSubmit}
            methods={methods}
            isLoading={formButtonLoading[formName]}
            submitButtonText='Submit'
            onCancel={closeModal}
            showSubmit
            submitContainerClassName='flex gap-2 justify-end py-4 px-4'
        >
            <div className='px-3 flex justify-between w-full'>
                <Teams org_check_required name='teams' label='Teams' org_id={org_id} isMulti={true} className='w-full' filter={existingTeamIds} />
            </div>
        </Form>
    );
}
